import type { FaireProductEntity } from "../../entity_types/product";

export const p_r7tdbzj6um: FaireProductEntity = {
  token: "p_r7tdbzj6um",
  type: "product",
  name: "V-Neck Bubble Sleeve Fishtail Gown",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Aria Romance",
  imageUrl:
    "https://cdn.faire.com/fastly/5ec92c9e6f36f2767f6bd3989ee4eeed0412fafaa8572518adac5b7ff75271cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57caf6d68c2221bad8d0ac13817a3f625160a44c50dc5d20f4c546327a9bb71c.jpeg",
    "https://cdn.faire.com/fastly/1c2d6a58baa7a89152375192529a034c09aa631b78140ccf436a2e64c0b2f065.jpeg",
    "https://cdn.faire.com/fastly/f87e7ae57665f43ec4dd621eb0260c293f8ffefecda2ff7cff04b1db12ea9228.jpeg",
    "https://cdn.faire.com/fastly/11330c37a507280efa660279f1f2ece0149dd2af1c7cf62b81ecda87ad2cfed1.jpeg",
    "https://cdn.faire.com/fastly/b42fab37a9230ce3a3e53053bb2bce10fe77f68a6b1c49ee5e32c5bf17380a46.jpeg",
    "https://cdn.faire.com/fastly/7cab684cc6109a0b6089265fe25ca558d8ff735afcbcdcbc534b92f1309a6251.jpeg",
  ],
  priceDollars: 31.2,
  description:
    "MAKE A DRAMATIC ENTRANCE IN THIS ELEGANT FISHTAIL GOWN, FEATURING VOLUMINOUS BUBBLE SLEEVES AND A FLATTERING V-NECK FOR A SHOWSTOPPING SILHOUETTE.\n\nIMPORTED, DESIGNED IN USA\n\nVOLUMINOUS PUFF SLEEVES AND FITTED BODICE\n\nDRAMATIC FISHTAIL HEM AND FLOWING SKIRT\n\nCONT 100% POLYESTER\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nShips from China. All Tax and duty covered",
  tags: [],
  msrpDollars: 54.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:18.336Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
